export default __webpack_public_path__ + "static/media/photos.c14e27e7.png";